const newLetterConstantsEn = {
  thumbnail: 'Thumbnail URL',
  publishSwitch: 'Published',
  minutesOfReading: 'Minutes Of Reading',
  newARTags: 'Arabic Tags',
  newENTags: 'English Tags',
  thumbnailValidation: 'Please enter Thumbnail',
  editNew: 'Edit News',
  createNew: 'Add New News Letter',
};

export default newLetterConstantsEn;
